/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExportExcelData = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2H4v8H1v9h3v3h11v-2H6v-1h4v-9H6V4h7v5h5v5h2V7.586l-.293-.293-5-5L14.414 2H14zm11.586 5H15V5.414zm4.121 9.293L20 15.586l-.707.707-3 3 1.414 1.414L19 19.414V23h2v-3.586l1.293 1.293 1.414-1.414zM3.26 17l1.501-2.526-1.427-2.345h1.2l1.004 1.682.979-1.682h1.152l-1.434 2.365L7.743 17h-1.2l-1.085-1.843L4.413 17z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExportExcelData as ExportExcelData };
